// components/ReservationSection.jsx

import React from "react";
import styles from "../styles/ReservationSection.module.css";
import hero from "../assets/hero.jpg";

export default function ReservationSection() {
  return (
    <section className={styles.section} id="reservation" style={{backgroundImage: `url(${hero})`}}>
      <div className={styles.overlay}></div>

      <div className={styles.content}>
        <span>Reservation</span>

        <h2>Book Your Table Today</h2>

        <p>
          Enjoy unforgettable Mediterranean flavors and elegant dining in the
          heart of Corfu.
        </p>

        <a href="tel:+302661043383">Call For Reservation</a>
      </div>
    </section>
  );
}